var map = {
	"./music-instructions.json": 4788,
	"./music-library-intro2024.json": 4789,
	"./music-library-launch2024.json": 4790,
	"./music-progression.json": 4791,
	"./startSourcesAdvanced.json": 4792,
	"./startSourcesSimple.json": 4793,
	"./startSourcesSimple2.json": 4794,
	"./startSourcesTracks.json": 4795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4505;